import { v4 } from 'uuid'

import {
	ApiCollectionColumn,
	ApiCollectionData,
} from '@/endpoints/schemas/api-collection'

import { ensureValidData } from '../helpers'

export const defaultApiCollectionData: Readonly<ApiCollectionData> = {
	name: '',
	code: '',
	columns: [],
	columnsLastId: 0,
}

export const getInitialApiCollectionData = (
	name: string,
	code = '',
): ApiCollectionData => {
	return ensureValidData(
		{
			name,
			code,
		},
		defaultApiCollectionData,
	)
}

export const createEmptyColumn = (
	columns: ApiCollectionColumn[],
): ApiCollectionColumn => ({
	id: -1,
	uuid: v4(),
	order: columns.length,
	name: '',
	notNull: false,
})
